/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Flow_Add_ResolutionInputs */

const en_task_flow_add_resolution = /** @type {(inputs: Task_Flow_Add_ResolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add resolution`)
};

const pt_br2_task_flow_add_resolution = /** @type {(inputs: Task_Flow_Add_ResolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar resolução`)
};

/**
* | output |
* | --- |
* | "Add resolution" |
*
* @param {Task_Flow_Add_ResolutionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_flow_add_resolution = /** @type {((inputs?: Task_Flow_Add_ResolutionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Flow_Add_ResolutionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_flow_add_resolution(inputs)
	return pt_br2_task_flow_add_resolution(inputs)
});